import React, { useState, createContext, useEffect, useContext} from "react"
import axios from 'axios'
import moment from 'moment';

import APIS, { theLab_url } from "../utils/APIS"
import { getCurrentUser } from "../utils/auth"

export const ScansContext = createContext()

export let colorByFamily = [
  {family: "communication", text : "#D4724B", bg : "#FFF4EF", border : "#D4724B"},
  {family: "efficacite", text : "#3E86B4", bg : "#EFF8FE", border : "#3E86B4"},
  {family: "leadership", text : "#F390FF", bg : "#FDEBFF", border : "#F390FF"},
]

export const compareScoresForValidation = (certif, scores, user, scan) => {
  if (certif?.length > 0) {
    for (let i=0; i<certif?.length;i++) {
      let skill = certif[i]

      let findInScores = scores[skill.key]
      if (findInScores) {
        if (findInScores?.score < skill.seuil) {
          return false
          break;
        }
      } else {
        return false
        break;
      }
    }

    return true
  } else {
    return false
  }
}

const ScansProvider = ({ children }) => {

  const [scans, setScans] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)


  useEffect(() => {
    getScans()
  }, [])

  const getScans = () => {
    let userType = getCurrentUser().type
    if (userType === "theScanRecruiter" || userType === "theScanCandidat") {
      APIS.getScans({userType: userType}).then(result => {
        if (userType === "theScanRecruiter" && result?.message === "getScansForRecruiter" && result?.scans) {
          let scansList = result?.scans
          scansList.forEach((scan) => {
            scan.invitedCounter = 0
            scan.completedCounter = 0
            scan.completedUsers = []
            scan.passedCounter = 0
            scan.passedUsers = []
            scan.userResults = []
            if (scan?.plan?.plan?.length > 0) {
              let moduleID = scan?.plan?.plan[0]?.id
              //on compte le nombre d'users invités
              if (scan?.userIDs?.length) {
                scan.invitedCounter = scan?.userIDs?.length
              }
              let findModule = result?.modules?.find((el) => el.id === moduleID)
              if (findModule) {
                scan.isOpen = moment(scan?.plan?.plan[0]?.openDate) <= moment(new Date()) && moment(scan?.plan?.plan[0]?.closeDate) >= moment(new Date())
                scan.module = findModule
                scan.playable = true
                scan.statut = "pret"

                //on compte pour le nombre de complétés
                if (result?.userResults) {
                  /* B59 (26/09/2026) : une COPIE par scan. Deux scans du meme recruteur
                     sur le meme module partageaient les memes objets resultat : chaque
                     scan reecrivait `validationResult` avec SES seuils, et la ligne du
                     candidat affichait le verdict du dernier scan de la liste, pas du
                     sien (la cloche, calculee scan par scan cote back, disait autre
                     chose). */
                  /* B64 (28/09/2026) : seulement les candidats invites dans CE scan. Le
                     back rend les resultats de TOUS les scans du recruteur : un autre scan
                     sur le meme module gonflait « Completes » et « Reussis » (« Invites 1 ·
                     Completes 9 »). Depuis B67, le back ne rend plus que les couples
                     (candidat, module) de ses scans ; ce filtre reste la regle d'UN scan. */
                  const invites = new Set((scan?.userIDs || []).map((el) => el?.userID))
                  let filterResultsByContentID = (result?.userResults?.filter((el) => el.contentID === findModule?.id && invites.has(el.userID)) || []).map((el) => ({ ...el }))
                  scan.userResults = filterResultsByContentID
                  // Alerte de temps (13/10) : memes regles que les resultats, un scan a la fois.
                  scan.alertesTemps = (result?.alertesTemps || []).filter((el) => el.contentID === findModule?.id && invites.has(el.userID))
                  scan.signauxNavigateur = (result?.signauxNavigateur || []).filter((el) => el.contentID === findModule?.id && invites.has(el.userID))
                  scan.signauxNavigateurDisponibles = result?.signauxNavigateurDisponibles !== false // absent (ancien back) = disponible
                  let filterCompleted = filterResultsByContentID?.filter((el) => (el.progress === 100 && el.isDone === true))
                  scan.completedUsers = filterCompleted?.map((el) => {
                    return scan?.userIDs?.find((el2) => el2.userID === el.userID)
                  })
                  scan.completedCounter = filterCompleted?.length


                  //si on a des complétés, on regarde pour les réussis
                  if (filterCompleted.length > 0) {
                    let seuils = []
                    //on va chercher les softskills
                    let softSkills = null
                    if (scan?.module?.softSkills) {
                      softSkills = JSON.parse(JSON.stringify(scan?.module?.softSkills))?.filter((el) => el.value === "oui")
                    }
                    let findCertif = scan?.certification?.find((el) => (el.id === scan?.module?.id && el.softSkills?.length > 0))
                    softSkills?.forEach((skill) => {
                      let findInCertif = findCertif?.softSkills?.find((el) => el.key === skill.key)
                      if (findInCertif) {
                        skill.seuil = findInCertif?.validation
                      } else {
                        skill.seuil = null
                      }
                    })
                    softSkills = softSkills?.filter((el) => el.seuil !== null)
                    scan.finalSoftSkills = softSkills

                    scan?.userResults?.forEach((user) => {
                      if (user?.progress === 100 && user?.isDone === true && user?.resultFin) {
                        let resultFin = JSON.parse(user?.resultFin)
                        //pour chaque user, on compare chaque score
                        user.validationResult = compareScoresForValidation(softSkills, resultFin, user, scan)
                      }
                    })

                    //on compte ceux qui ont réussi
                    let filterPassed = scan?.userResults?.filter((el) => (el.validationResult === true))
                    scan.passedCounter = filterPassed?.length
                    scan.passedUsers = filterPassed?.map((el) => {
                      return scan?.userIDs?.find((el2) => el2.userID === el.userID)
                    })
                  }
                }
              } else {
                // Un module est planifie mais introuvable cote contenus : anomalie
                // de donnees, pas une attente normale. Le recruteur ne peut rien y
                // faire, on le dit au lieu d'afficher "en cours d'analyse" a vie.
                scan.playable = false
                scan.statut = "module_introuvable"
              }
            } else {
              // Cas nominal juste apres la creation : le back enregistre un plan
              // vide, un expert Rising Up doit encore choisir l'evaluation.
              scan.playable = false
              scan.statut = "en_attente_preparation"
            }
          })
          setScans(scansList)
          setIsLoaded(true)
        } else if (userType === "theScanCandidat" && result?.message === "getScansForCandidat" && result?.scans) {
          let finalList = []
          let scansList = result?.scans
          scansList.forEach((scan) => {
            if (scan?.plan?.plan?.length > 0) {
              let moduleID = scan?.plan?.plan[0]?.id
              let findModule = result?.modules?.find((el) => el.id === moduleID)
              if (findModule) {
                scan.isOpen = moment(scan?.plan?.plan[0]?.openDate) <= moment(new Date()) && moment(scan?.plan?.plan[0]?.closeDate) >= moment(new Date())
                scan.module = findModule
                let findInUserFormations = result?.userFormations?.find((el) => el.id === moduleID)
                if (findInUserFormations) { //on a trouvé ce module dans la liste des formations en cours / terminées
                  scan.userFormations = findInUserFormations
                  /* B45 (25/09/2026) : le back rend `isDone` en booleen
                     (typeCast de config/connection.js) ; `=== 1` n'etait jamais
                     vrai, et un candidat qui avait fini voyait « Continuer ». */
                  const termine = scan.userFormations?.isDone === true || scan.userFormations?.isDone === 1
                  if (termine && scan.userFormations?.progress === 100) {
                    /* PD-10 (25/09/2026) : decision d'Hicham, un candidat ne voit
                       AUCUNE statistique de ses resultats. On ne calcule donc plus
                       scan.finalSoftSkills (competences retenues et seuils de
                       validation du recruteur) cote candidat : seul le statut
                       « termine » sert a son ecran (« Termine le …, resultats
                       transmis au recruteur »). */
                    scan.scanStatus = "completed"
                  } else {
                    scan.scanStatus = "inProgress"
                  }
                } else {
                  scan.scanStatus = "notStarted"
                }
                finalList.push(scan)
              }
            }
          })
          setScans(finalList)
          setIsLoaded(true)
        } else {
          alert("Erreur\u00a0!")
          setIsLoaded(false)
        }
      })
    } else if (userType === "student" || userType === "adminclient") {
      window.location.href = theLab_url
      setIsLoaded(false)
    } else {
      alert("Erreur\u00a0!")
      setIsLoaded(false)
    }
  }


  return (
    <ScansContext.Provider
      value={{
        isLoaded,
        scans,
        setScans,
        getScans,
        colorByFamily,
      }}
    >
      {children}
    </ScansContext.Provider>
  )
}

export default ScansContext

export { ScansProvider }
